import React from "react";
import { Box, Typography } from "@mui/material";
import DeviceSearchInput from "../../../Components/DeviceSearchInput";
import { MIN_SERIAL_SEARCH_LENGTH } from "../recordReplacementHelper";

// Thin wrapper over the platform search box (DeviceSearchInput) so the serial fields get
// the same suggestion dropdown as the inventory tables — same options list, same theme —
// while keeping this form's field border and helper-text line, which the search box itself
// deliberately has neither of.
export default function SerialSearchField({
    value,
    onValueChange,
    onSelect,
    searchSuggestionsHandler,
    suggestionLimit,
    onSuggestionsChange,
    error = false,
    isWarning = false,
    helperText = " ",
    placeholder,
    testId,
}) {
    return (
        <Box>
            <Box
                sx={{
                    backgroundColor: "#fff",
                    border: `1px solid ${error ? "#F04438" : "#D0D5DD"}`,
                    borderRadius: "8px",
                    px: "12px",
                    display: "flex",
                    alignItems: "center",
                    "&:focus-within": { borderColor: "#6D72F6" },
                }}
            >
                <DeviceSearchInput
                    value={value}
                    onValueChange={onValueChange}
                    onSelect={onSelect}
                    onSuggestionsChange={onSuggestionsChange}
                    searchSuggestionsHandler={searchSuggestionsHandler}
                    suggestionLimit={suggestionLimit}
                    placeholder={placeholder}
                    error={error}
                    autoFocus={false}
                    // Match the backend's search floor, otherwise a 2-character query fetches
                    // matches the dropdown then refuses to show.
                    minCharsToOpen={MIN_SERIAL_SEARCH_LENGTH}
                    inputProps={{ "data-testid": testId }}
                />
            </Box>
            <Typography
                sx={{
                    fontSize: "12px",
                    mt: "5px",
                    minHeight: "16px",
                    color: error ? "#F04438" : isWarning ? "#B54708" : "#6B6B6B",
                }}
            >
                {helperText}
            </Typography>
        </Box>
    );
}
